module.exports = __webpack_public_path__ + "static/media/09_negro.fd4db861.svg";